import type { IconName } from './Icon'

export interface NavItem {
  label: string
  path: string
  icon: IconName
  soon?: boolean
}

// Three groups separated by dividers in the sidebar.
export const NAV_GROUPS: NavItem[][] = [
  [
    { label: 'Getting Started', path: '/getting-started', icon: 'rocket' },
    { label: 'Playground', path: '/playground', icon: 'play' },
    { label: 'API Keys', path: '/api-keys', icon: 'key' },
  ],
  [
    { label: 'Toolkits', path: '/toolkits', icon: 'grid' },
    { label: 'MCP Directory', path: '/directory', icon: 'globe' },
    { label: 'Skills', path: '/skills', icon: 'spark', soon: true },
  ],
  [
    { label: 'Users', path: '/users', icon: 'users', soon: true },
    { label: 'Sessions', path: '/sessions', icon: 'clock' },
    { label: 'Auth Configs', path: '/auth-configs', icon: 'shield', soon: true },
    { label: 'Triggers', path: '/triggers', icon: 'bolt' },
    { label: 'Logs', path: '/logs', icon: 'list' },
    { label: 'Sandbox', path: '/sandbox', icon: 'box', soon: true },
    { label: 'Settings', path: '/settings', icon: 'settings' },
  ],
]

export const ALL_NAV: NavItem[] = NAV_GROUPS.flat()
